module.exports = "data:image/gif;base64,R0lGODlhCwAKAIAAAEFBQeXl5SH5BAAAAAAALAAAAAALAAoAAAIVjI+pAe3vVgSJNkMxtqzbq22ZBJUFADs="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon2.gif
// module id = 277
// module chunks = 0